import { default as accountcb5VAvVXVpMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/account.vue?macro=true";
import { default as indexrg8ubJA3eyMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/ad-library/index.vue?macro=true";
import { default as _91id_93PrbJhmw8fRMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/admin/template-categories/[id].vue?macro=true";
import { default as indexihprMOzDSOMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/admin/template-categories/index.vue?macro=true";
import { default as newzVbaCBAithMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/admin/template-categories/new.vue?macro=true";
import { default as edit_45metadataXCYdmjzhozMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/admin/templates/[id]/edit-metadata.vue?macro=true";
import { default as editor_46clientk0UXrWtV9kMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/admin/templates/[id]/editor.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/home/likit/Apps/hobby/adsonic/node_modules/.pnpm/nuxt@3.13.2_@types+node@20.12.2_eslint@8.57.0_sass@1.72.0_typescript@5.7.3_vite@5.4.9_vue-tsc@2.2.0/node_modules/nuxt/dist/components/runtime/client-component").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as indexJ1paOEeJs4Meta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/admin/templates/index.vue?macro=true";
import { default as _91id_930YOhZHRFHNMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/admin/visual-component-categories/[id].vue?macro=true";
import { default as indexnQVZPnvxOLMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/admin/visual-component-categories/index.vue?macro=true";
import { default as newStDDtPYjcJMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/admin/visual-component-categories/new.vue?macro=true";
import { default as indexSVgrgoQOqzMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/admin/visual-components/index.vue?macro=true";
import { default as _91id_93RsIkiNebFyMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/admin/visual-formats/[id].vue?macro=true";
import { default as indexglzhqOMgeIMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/admin/visual-formats/index.vue?macro=true";
import { default as newPqEzhvkNUAMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/admin/visual-formats/new.vue?macro=true";
import { default as assetsaXWUsw3m5uMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/assets.vue?macro=true";
import { default as _91id_93GeHTsmkC0yMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/brands/[id].vue?macro=true";
import { default as index48NoDm1QhnMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/brands/index.vue?macro=true";
import { default as newMkzT5kKRDjMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/brands/new.vue?macro=true";
import { default as campaignsxqWntdHUWlMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/campaigns.vue?macro=true";
import { default as dashboardXhLrdjbccpMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/dashboard.vue?macro=true";
import { default as generatedfedS41e76Meta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/image-ads/[id]/generate.vue?macro=true";
import { default as indexdTBXBO0QDvMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/image-ads/index.vue?macro=true";
import { default as brandlvhHFjZ6cPMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/onboarding/brand.vue?macro=true";
import { default as product5k7fL8Qk9GMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/onboarding/product.vue?macro=true";
import { default as team_45memberTO9D1ddwbZMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/onboarding/team-member.vue?macro=true";
import { default as teamV3x04QJNM2Meta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/onboarding/team.vue?macro=true";
import { default as fabricqSUrNJlYHLMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/playground/fabric.vue?macro=true";
import { default as video22LeMIMhAJMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/playground/video.vue?macro=true";
import { default as _91id_93iOds4EgGONMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/preview/[id].vue?macro=true";
import { default as _91id_932gJneUXYDQMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/preview/svg/[id].vue?macro=true";
import { default as pricingpDNIda6G43Meta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/pricing.vue?macro=true";
import { default as privacy_45policyuKuz7URwqHMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/privacy-policy.vue?macro=true";
import { default as _91id_933Up4fPxZwTMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/products/[id].vue?macro=true";
import { default as indexKC23TghkspMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/products/index.vue?macro=true";
import { default as new4V3W0xIHD6Meta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/products/new.vue?macro=true";
import { default as editor_46clientyF25HewsJDMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/projects/[id]/editor.client.vue?macro=true";
import { default as launch37vuzHiamZMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/projects/[id]/launch.vue?macro=true";
import { default as indexbZzXuGSdHyMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/projects/index.vue?macro=true";
import { default as socialkbkttflp4pMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/social.vue?macro=true";
import { default as accept_45invitationjNMKtjdiXXMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/team/[teamId]/accept-invitation.vue?macro=true";
import { default as index2TK2ZZdRrFMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/templates/index.vue?macro=true";
import { default as terms_45of_45servicelwR8wJdb89Meta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/terms-of-service.vue?macro=true";
import { default as login_45instructionsYBarWR3JagMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/users/login-instructions.vue?macro=true";
import { default as login_45with_45linkW3FcraWmnaMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/users/login-with-link.vue?macro=true";
import { default as loginUUNQePJTjRMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/users/login.vue?macro=true";
import { default as signupSOjuakAGLWMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/users/signup.vue?macro=true";
import { default as indexLlSvwllxF9Meta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/video-ads/index.vue?macro=true";
import { default as generatejGnCTewUNIMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/video-generator/generate.vue?macro=true";
import { default as indexYlnJrhaDiEMeta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/video-generator/index.vue?macro=true";
import { default as web_45ext_45authgIPRcAu326Meta } from "/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/web-ext-auth.vue?macro=true";
export default [
  {
    name: "account",
    path: "/account",
    meta: accountcb5VAvVXVpMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/account.vue")
  },
  {
    name: "ad-library",
    path: "/ad-library",
    meta: indexrg8ubJA3eyMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/ad-library/index.vue")
  },
  {
    name: "admin-template-categories-id",
    path: "/admin/template-categories/:id()",
    meta: _91id_93PrbJhmw8fRMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/admin/template-categories/[id].vue")
  },
  {
    name: "admin-template-categories",
    path: "/admin/template-categories",
    meta: indexihprMOzDSOMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/admin/template-categories/index.vue")
  },
  {
    name: "admin-template-categories-new",
    path: "/admin/template-categories/new",
    meta: newzVbaCBAithMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/admin/template-categories/new.vue")
  },
  {
    name: "admin-templates-id-edit-metadata",
    path: "/admin/templates/:id()/edit-metadata",
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/admin/templates/[id]/edit-metadata.vue")
  },
  {
    name: "admin-templates-id-editor",
    path: "/admin/templates/:id()/editor",
    component: () => createClientPage(() => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/admin/templates/[id]/editor.client.vue"))
  },
  {
    name: "admin-templates",
    path: "/admin/templates",
    meta: indexJ1paOEeJs4Meta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/admin/templates/index.vue")
  },
  {
    name: "admin-visual-component-categories-id",
    path: "/admin/visual-component-categories/:id()",
    meta: _91id_930YOhZHRFHNMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/admin/visual-component-categories/[id].vue")
  },
  {
    name: "admin-visual-component-categories",
    path: "/admin/visual-component-categories",
    meta: indexnQVZPnvxOLMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/admin/visual-component-categories/index.vue")
  },
  {
    name: "admin-visual-component-categories-new",
    path: "/admin/visual-component-categories/new",
    meta: newStDDtPYjcJMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/admin/visual-component-categories/new.vue")
  },
  {
    name: "admin-visual-components",
    path: "/admin/visual-components",
    meta: indexSVgrgoQOqzMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/admin/visual-components/index.vue")
  },
  {
    name: "admin-visual-formats-id",
    path: "/admin/visual-formats/:id()",
    meta: _91id_93RsIkiNebFyMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/admin/visual-formats/[id].vue")
  },
  {
    name: "admin-visual-formats",
    path: "/admin/visual-formats",
    meta: indexglzhqOMgeIMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/admin/visual-formats/index.vue")
  },
  {
    name: "admin-visual-formats-new",
    path: "/admin/visual-formats/new",
    meta: newPqEzhvkNUAMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/admin/visual-formats/new.vue")
  },
  {
    name: "assets",
    path: "/assets",
    meta: assetsaXWUsw3m5uMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/assets.vue")
  },
  {
    name: "brands-id",
    path: "/brands/:id()",
    meta: _91id_93GeHTsmkC0yMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/brands/[id].vue")
  },
  {
    name: "brands",
    path: "/brands",
    meta: index48NoDm1QhnMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/brands/index.vue")
  },
  {
    name: "brands-new",
    path: "/brands/new",
    meta: newMkzT5kKRDjMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/brands/new.vue")
  },
  {
    name: "campaigns",
    path: "/campaigns",
    meta: campaignsxqWntdHUWlMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/campaigns.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: dashboardXhLrdjbccpMeta || {},
    alias: ["/"],
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/dashboard.vue")
  },
  {
    name: "image-ads-id-generate",
    path: "/image-ads/:id()/generate",
    meta: generatedfedS41e76Meta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/image-ads/[id]/generate.vue")
  },
  {
    name: "image-ads",
    path: "/image-ads",
    meta: indexdTBXBO0QDvMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/image-ads/index.vue")
  },
  {
    name: "onboarding-brand",
    path: "/onboarding/brand",
    meta: brandlvhHFjZ6cPMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/onboarding/brand.vue")
  },
  {
    name: "onboarding-product",
    path: "/onboarding/product",
    meta: product5k7fL8Qk9GMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/onboarding/product.vue")
  },
  {
    name: "onboarding-team-member",
    path: "/onboarding/team-member",
    meta: team_45memberTO9D1ddwbZMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/onboarding/team-member.vue")
  },
  {
    name: "onboarding-team",
    path: "/onboarding/team",
    meta: teamV3x04QJNM2Meta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/onboarding/team.vue")
  },
  {
    name: "playground-fabric",
    path: "/playground/fabric",
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/playground/fabric.vue")
  },
  {
    name: "playground-video",
    path: "/playground/video",
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/playground/video.vue")
  },
  {
    name: "preview-id",
    path: "/preview/:id()",
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/preview/[id].vue")
  },
  {
    name: "preview-svg-id",
    path: "/preview/svg/:id()",
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/preview/svg/[id].vue")
  },
  {
    name: "pricing",
    path: "/pricing",
    meta: pricingpDNIda6G43Meta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/pricing.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/privacy-policy.vue")
  },
  {
    name: "products-id",
    path: "/products/:id()",
    meta: _91id_933Up4fPxZwTMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/products/[id].vue")
  },
  {
    name: "products",
    path: "/products",
    meta: indexKC23TghkspMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/products/index.vue")
  },
  {
    name: "products-new",
    path: "/products/new",
    meta: new4V3W0xIHD6Meta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/products/new.vue")
  },
  {
    name: "projects-id-editor",
    path: "/projects/:id()/editor",
    meta: editor_46clientyF25HewsJDMeta || {},
    component: () => createClientPage(() => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/projects/[id]/editor.client.vue"))
  },
  {
    name: "projects-id-launch",
    path: "/projects/:id()/launch",
    meta: launch37vuzHiamZMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/projects/[id]/launch.vue")
  },
  {
    name: "projects",
    path: "/projects",
    meta: indexbZzXuGSdHyMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/projects/index.vue")
  },
  {
    name: "social",
    path: "/social",
    meta: socialkbkttflp4pMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/social.vue")
  },
  {
    name: "team-teamId-accept-invitation",
    path: "/team/:teamId()/accept-invitation",
    meta: accept_45invitationjNMKtjdiXXMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/team/[teamId]/accept-invitation.vue")
  },
  {
    name: "templates",
    path: "/templates",
    meta: index2TK2ZZdRrFMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/templates/index.vue")
  },
  {
    name: "terms-of-service",
    path: "/terms-of-service",
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/terms-of-service.vue")
  },
  {
    name: "users-login-instructions",
    path: "/users/login-instructions",
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/users/login-instructions.vue")
  },
  {
    name: "users-login-with-link",
    path: "/users/login-with-link",
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/users/login-with-link.vue")
  },
  {
    name: "users-login",
    path: "/users/login",
    meta: loginUUNQePJTjRMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/users/login.vue")
  },
  {
    name: "users-signup",
    path: "/users/signup",
    meta: signupSOjuakAGLWMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/users/signup.vue")
  },
  {
    name: "video-ads",
    path: "/video-ads",
    meta: indexLlSvwllxF9Meta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/video-ads/index.vue")
  },
  {
    name: "video-generator-generate",
    path: "/video-generator/generate",
    meta: generatejGnCTewUNIMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/video-generator/generate.vue")
  },
  {
    name: "video-generator",
    path: "/video-generator",
    meta: indexYlnJrhaDiEMeta || {},
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/video-generator/index.vue")
  },
  {
    name: "web-ext-auth",
    path: "/web-ext-auth",
    component: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/pages/web-ext-auth.vue")
  }
]